import React from 'react';
import EcommDataNumberRow from '../components/EcommDataAssignment/EcommDataNumberRow';
import EcommDataDropdownRow from '../components/EcommDataAssignment/EcommDataDropdownRow';

export const numberRowMap = (canEdit, handleChange, getTabIndex, locationData) => (item) =>
  <EcommDataNumberRow
    getTabIndex={getTabIndex}
    key={item.title}
    canEdit={canEdit}
    handleChange={handleChange}
    locationData={locationData}
    rowTitle={item.title}
    valueKey={item.valueKey}
  />

export const dropdownRowMap = (canEdit, handleChange, getTabIndex, locationData) => (item) =>
  <EcommDataDropdownRow
    canEdit={canEdit}
    getTabIndex={getTabIndex}
    key={item.title}
    handleChange={handleChange}
    locationData={locationData}
    options={item.options}
    rowTitle={item.title}
    valueKey={item.valueKey}
  />
